var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9252 13.8625L7.95644 8.9125C7.59394 9.225 7.1627 9.46875 6.6627 9.64375C6.1627 9.81875 5.63145 9.90625 5.06895 9.90625C3.69395 9.90625 2.52832 9.43125 1.57207 8.48125C0.61582 7.53125 0.137695 6.38125 0.137695 5.03125C0.137695 3.68125 0.61582 2.53125 1.57207 1.58125C2.52832 0.63125 3.68145 0.15625 5.03145 0.15625C6.38145 0.15625 7.53145 0.63125 8.48145 1.58125C9.43145 2.53125 9.90644 3.68125 9.90644 5.03125C9.90644 5.56875 9.81894 6.0875 9.64394 6.5875C9.46894 7.0875 9.2127 7.55625 8.87519 7.99375L13.8627 12.925L12.9252 13.8625ZM5.0502 8.63125C6.03769 8.63125 6.87832 8.27812 7.57207 7.57187C8.26582 6.86562 8.61269 6.01875 8.61269 5.03125C8.61269 4.04375 8.26582 3.19688 7.57207 2.49063C6.87832 1.78438 6.03769 1.43125 5.0502 1.43125C4.0377 1.43125 3.18145 1.78438 2.48145 2.49063C1.78145 3.19688 1.43145 4.04375 1.43145 5.03125C1.43145 6.01875 1.78145 6.86562 2.48145 7.57187C3.18145 8.27812 4.0377 8.63125 5.0502 8.63125Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.f6bf637e.svg";
export { ForwardRef as ReactComponent };